<template>
    <app-section bgIntro="lighter" class="-about">
        <template #intro>
            <div class="l-section__deco">
                <div class="l-section__deco-inner" v-view="viewDeco" ref="viewDeco">
                    <icon v-for="i in [1, 2, 3, 4, 5, 6, 7, 8]" :key="i" size="xl" icon="arrow-up" />
                </div>
            </div>

            <div class="c-box">
                <h2 class="l-section__title | t-t4-heavy-bold">
                    <anim-text :text="data.title" />
                </h2>

                <ul v-if="data.partners.length" class="o-partners">
                    <li v-for="(partner, i) in data.partners" :key="`partner-${i}`">
                        <a
                            v-if="partner.website"
                            :href="partner.website.url"
                            :title="partner.name"
                            target="_blank"
                            rel="noopener"
                        >
                            <icon :icon="partner.logo" />
                        </a>
                    </li>
                </ul>

                <hr />

                <h2 v-if="data.extra_partners_title" class="l-section__title | t-t4-heavy-bold">
                    <anim-text :text="data.extra_partners_title" />
                </h2>

                <ul v-if="data.extra_partners.length" class="o-partners">
                    <li v-for="(partner, i) in data.extra_partners" :key="`extra-partner-${i}`">
                        <a
                            v-if="partner.website"
                            :href="partner.website.url"
                            :title="partner.name"
                            target="_blank"
                            rel="noopener"
                        >
                            <img
                                class="o-img"
                                :class="`-${partner.logo}`"
                                :src="require(`assets/img/about/logo-${partner.logo}.png`)"
                            />
                        </a>
                    </li>
                </ul>
                <!-- <h3 class="c-box__press">
                    <anim-text :text="$t('global.pressKit')" />
                </h3>
                <btn
                    v-if="data.press_file"
                    tag="a"
                    :label="$t('btn.downloadKit')"
                    :href="data.press_file.url"
                    iconAfter="download"
                    target="_blank"
                    rel="noopener"
                    :isFullWidth="true"
                /> -->
            </div>
            <div class="l-section__bottom">
                <div class="l-section__arrows">
                    <icon v-for="i in [1, 2, 3]" :key="i" icon="arrow-right" />
                </div>
                <hr />
                <p class="l-section__push">
                    <anim-text :text="$t('global.gotQuestions')" />
                </p>
                <a
                    v-if="data.email"
                    :href="`mailto:${data.email}`"
                    title="Contacter le mois de l'économie sociale"
                    class="t-link"
                >
                    {{ data.email }}
                </a>
            </div>
        </template>
    </app-section>
</template>

<script>
import AppSection from "layout/AppSection";
import AnimText from "objects/AnimText";
import Asset from "objects/Asset";
import Icon from "objects/Icon";
import Btn from "components/Btn";

import Variables from "src/mixins/variables";

import gsap from "gsap";

export default {
    name: "About",
    components: {
        Asset,
        AnimText,
        AppSection,
        Btn,
        Icon,
    },
    mixins: [Variables],
    data: () => ({
        x: 0,
        y: 0,
    }),
    mounted() {
        this.x = 0;
        this.y = this.ifHorizontal(this.W.h / 10, 0);
    },
    computed: {
        data() {
            return this.$store.getters["global/getPageByHandle"]("about").data;
        },
    },
    methods: {
        viewDeco(e) {
            if (this.isHorizontal) {
                this.y = (e.percent.left * this.W.h) / 10;
            } else {
                this.x = (-e.percent.top * this.W.w) / 10;
            }
        },
    },
    watch: {
        x(x) {
            gsap.to(this.$refs.viewDeco, {
                duration: 0.2,
                x: x,
                ease: "sine.out",
            });
        },
        y(y) {
            gsap.to(this.$refs.viewDeco, {
                duration: 0.2,
                y: y,
                ease: "sine.out",
            });
        },
        isHorizontal(horizontal) {
            if (horizontal) {
                this.x = 0;
            } else {
                this.y = 0;
            }
        },
    },
};
</script>
